// extracted by mini-css-extract-plugin
export default {"SearchModal":"DocumentSearchModal_SearchModal__inoT7"};